import { type FC, useEffect, useRef } from "react";
import { DefinitionList } from "@root/shared/components/DefinitionList";
import { useReadMoreButtonHeight } from "@root/shared/components/ReadMoreButton/useReadMoreButtonHeight";
import * as styles from "./styles.css";

type Props = {
  userAchievementsInfoList: { term: string; description: string | string[] }[][];
};

export const UserAchievementsDefinitionList: FC<Props> = ({ userAchievementsInfoList }) => {
  const setContainerHeight = useReadMoreButtonHeight();
  const elementRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (elementRef.current && setContainerHeight) {
      // ボタンを表示する高さは一つ目の要素の高さ
      setContainerHeight(elementRef.current.clientHeight);
    }
  }, [setContainerHeight]);

  return (
    <>
      {userAchievementsInfoList.map((userAchievementsInfoListItems, index) => (
        <DefinitionList
          // eslint-disable-next-line react/no-array-index-key
          key={`${userAchievementsInfoListItems[0].term}_${index}`}
          title={`受賞・表彰歴${index + 1}`}
          items={userAchievementsInfoListItems}
          className={styles.definitionListContainer}
          elementRef={index === 0 ? elementRef : null}
        />
      ))}
    </>
  );
};
